<template>
  <div
    class="scan-login"
    :class="{app:!env}"
  >
    <div class="top">
      <img
        class="logo"
        src="@assets/images/logo1.png"
      >
    </div>
    <div
      id="QRcode"
      class="qrcode"
    />
    <div class="bottom">
      <p class="p1">
        请使用手机钉钉扫码登录
      </p>
      <p class="p2">
        进入校宝绩效管理平台
      </p>
    </div>
    <remoteJs
      :js-url="'https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js'"
      :js-load-call-back="loadRongJs"
    />
  </div>
</template>

<script>
import remoteJs from '@components/remote-js/index.vue'
import { mapState } from 'vuex'
import { message } from 'ant-design-vue'

export default {
  name: 'Unauthorized',
  components: {
    remoteJs,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      env: state => state.env,
    }),
  },
  watch: {},
  mounted() {},
  methods: {
    async loadRongJs() {
      try {
        const result = await this.$api.user.getConfig()
        const appId = result.snsAppId
        const callBackUrl = result.snsCallbackUrl
        // eslint-disable-next-line
        console.log(result)
        const handleMessage = function(event) {
          const origin = event.origin
          if (origin === 'https://login.dingtalk.com') {
          // 判断是否来自ddLogin扫码事件。
            const loginTmpCode = event.data // 拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
            if (window.location) {
            // 开发环境扫码appid: dingoaklb6hotji6etvoce ,测试环境扫码appid：dingoay5fvgm3tlb1vjc5d, 生产环境扫码appid：dingoazczz12pskgjgfbrp
              const url = `${`${'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?' +
            'appid='}${appId}&response_type=code&scope=snsapi_login&state=STATE&` +
            `loginTmpCode=`}${loginTmpCode}`
              window.location.href = url
            }
          }
        }
        if (typeof window.addEventListener !== 'undefined') {
          window.addEventListener('message', handleMessage, false)
        } else if (typeof window.attachEvent !== 'undefined') {
          window.attachEvent('onmessage', handleMessage)
        }
        const redirectUri = encodeURIComponent(
          `${callBackUrl}${this.$route.query.url ?
            `?redirect=${this.$route.query.url}` : ''}`
        )

        const url = encodeURIComponent(
        // 开发环境扫码appid: dingoaklb6hotji6etvoce，redirect_uri:http://www.okr.com:8080/authorize ,
        // 测试环境扫码appid：dingoay5fvgm3tlb1vjc5d，
        // redirect_uri:http://testokr.xiaobaoonline.com/authorize
          `${`${'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?' +
        'appid='}${appId}&response_type=code&scope=snsapi_login&state=STATE&` +
        `redirect_uri=`}${redirectUri}`
        )

        DDLogin({
          id: 'QRcode',
          goto: url,
          style: 'border:none;background-color:#fff;border-radius:inherit',
          width: '400',
          height: '300',
        })

      // 当使用远程js里的内容时请添加"//eslint-disable-line"防止eslint检测报错
      // console.log(RongIMLib) //eslint-disable-line
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

.scan-login {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f0f2f5;
    .top {
        height: 100px;
        width: 400px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .logo {
            // width: 120px;
            height: 25px;
        }
    }
    .qrcode {
        width: 400px;
        background: #fff;
        height: 300px;
    }
    .bottom {
        padding-top: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        width: 400px;
        height: 160px;
        background: #fff;
        color: rgba(0, 0, 0, 0.85);
        .p1 {
            font-size: 24px;
            font-weight: 600;
        }
        .p2 {
            font-size: 16px;
            font-weight: 400;
        }
    }
}
.scan-login.app{
    background-color: #fff;
}
</style>
